<script>
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import { formatDatetime } from "@/helpers/common";
import {getDeviceInfo} from "@/helpers/common-service";
import {workOrderList} from "@/service";
import _ from 'lodash'
import vueQr from "vue-qr/src/packages/vue-qr.vue";
import { WO_TYPE } from "@/config/common";

SwiperCore.use([Navigation]);
export default {
  props: {
    woData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data () {
    return {
      WO_TYPE,
      checkTabVal: '1',
      tabOptions: [
        {
          value: '1',
          text: this.$t('page.deviceInfo')
        },
        {
          value: '2',
          text: this.$t('page.maintenanceRecord')
        },
        // {
        //   value: '3',
        //   text: '维保套餐'
        // }
      ],
      dataList: [],
      maintenancePackage: [],
      device: {},
      deviceImgs: [],
      qrcodeLogo: require("@/assets/images/u11.jpeg"),
    }
  },
  mounted() {


  },
  methods: {
    formatDatetime,
    deviceInfo(root_sn) {
      getDeviceInfo(root_sn, true, true).then(res => {
        this.device = res
        if(this.device.attributes&&this.device.attributes.attributes.length>0){
          this.device['model'] = this.device.attributes.attributes.filter(item=>{
            return item.name==="设备型号"
          })[0].value
        }
        this.deviceImgs = _.get(res, 'files.image', [])
        this.setQRcodeUrl(res.attributes.attributes, res.extra_info)
        this.$emit('deviceLoaded', res)
      })
    },
    getField(name) {
      return _.get(this.device, name, '')
    },
    //生成二维码
    setQRcodeUrl(attributes, extra_info) {
      let qrcodeCheckedList = extra_info.qrcodeCheckedList;
      let codes = "";
      if(attributes){
        attributes.map((attr) => {
          if (
              attr.group === this.$t('page.work-order.device.equipment_delivery_information') &&
              (!qrcodeCheckedList || qrcodeCheckedList.includes(attr.id))
          ) {
            let unit = attr.unit == this.$t('page.no') ? "" : attr.unit;
            codes += `${attr.name}:${attr.value} ${unit};`;
          }
        });
      }
      this.qrCodeValue = codes;
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    vueQr,
  },
  computed:{
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  watch: {
    woData: {
      immediate: true,
      deep: true,
      handler(val) {
        // 根据root_sn获取设备信息
        if (val.device_root_sn) {
          this.deviceInfo(this.woData.device_root_sn)
        } else {
          this.device = {}
          this.deviceImgs = []
        }
        // 获取维保记录:相同设备的工单，除已取消状态的，不分页
        if (val.device_root_sn) {
          workOrderList({
            device_root_sn: val.device_root_sn,
            status: '1,2,3',
            ordering: '-created_at,status',
            page: 1,
            page_size: 0
          }).then(res => {
            this.dataList = res.payload
          })
        }
      }
    }
  }

}
</script>
<template>
  <b-row>
    <b-col>
      <b-card>
        <b-card-body>
          <b-row>
            <b-col cols="4">
              <div v-if="!deviceImgs.length" class="text-muted d-flex justify-content-center align-items-center" style="height: 100%;">
                {{ $t('page.no_image') }}
              </div>
              <div class="product-img-slider sticky-side-div">
                <swiper
                    ref="imgSwiper"
                    :navigation="{
                        nextEl: '.swiper-device-button-next',
                        prevEl: '.swiper-device-button-prev'
                    }"
                >
                  <swiper-slide v-for="(item, index) in deviceImgs" :key="index">
                    <div>
                      <img :src="item.url" alt class="img-fluid d-block w-100" />
                    </div>
                  </swiper-slide>
                </swiper>
                <div v-show="deviceImgs.length > 1" class="swiper-button-prev swiper-device-button-prev"></div>
                <div v-show="deviceImgs.length > 1" class="swiper-button-next swiper-device-button-next"></div>

              </div>
            </b-col>
            <b-col>
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h4 class="text-primary">{{ woData.device_name }}</h4>
                  <div  v-if="user&&user.user_type!=='customer'" class="hstack gap-3 flex-wrap">
                    <div class="text-muted">
                      {{ $t('page.powerOnTime') }} :
                      <span class="text-body fw-medium">-</span>
                    </div>
                    <div class="vr"></div>
                    <div class="text-muted">
                      {{ $t('page.deviceStatus') }} :
                      <span class="text-body fw-medium">{{ $t(getField('status')) }}</span>
                    </div>
                    <div class="vr"></div>
                    <div class="text-muted">
                      {{ $t('page.locationOn') }} :
                      <span class="text-body fw-medium">{{ getField('location') }}</span>
                    </div>
                  </div>
                </div>
                <div class="flex-shrink-0">
                  <div style="height:100px;width: 100px;">
                    <vue-qr
                        v-if="qrCodeValue"
                        ref="qrcode"
                        :text="qrCodeValue + ' '"
                        :logo-src="qrcodeLogo"
                        :size="100"
                        :margin="10"
                        :logoMargin="2"
                        :backgroundColor="'#fff'"
                    ></vue-qr>
                  </div>
                  <!--                  <div>-->
                  <!--                    <img src="@/assets/images/normal_u66.png" style="width: 60px;">-->
                  <!--                  </div>-->
                </div>
              </div>

              <div class="border-bottom-dashed border-top-dashed py-4 my-5">
                <b-row>
                  <b-col cols="3">
                    <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.workOrderCreationTime') }}</p>
                    <h5 class="fs-14 mb-0"><span>{{ formatDatetime(woData.created_at) }}</span></h5>
                  </b-col>
                  <b-col cols="3">
                    <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.estimatedArrivalTime') }}</p>
                    <h5 class="fs-14 mb-0"><span>{{ woData.plan_start_at }}</span></h5>
                  </b-col>
                  <b-col cols="3">
                    <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.estimatedCompletionTime') }}</p>
                    <h5 class="fs-14 mb-0"><span>{{ woData.plan_end_at }}</span></h5>
                  </b-col>
                  <b-col cols="3">
                    <p class="text-muted mb-2 text-uppercase fw-semibold">{{ $t('page.customerName') }}</p>
                    <h5 class="fs-14 mb-0"><span>{{ woData.customer_txt }}</span></h5>
                  </b-col>
                </b-row>
              </div>

              <h5 class="mb-4">{{ $t('page.deviceInfo') }}</h5>
              <nav>
                <ul class="nav nav-tabs nav-tabs-custom nav-primary" role="tablist">
                  <li class="nav-item" v-for="(item, index) in tabOptions" :key="index" @click="checkTabVal = item.value">
                    <b-link class="nav-link fw-semibold text-body" :class="item.value == checkTabVal ? 'active' : ''" role="tab">
                      {{ item.text }}
                    </b-link>
                  </li>
                </ul>
              </nav>

              <div v-show="checkTabVal == '1'" class="tab-content border border-top-0 p-4">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="nav-speci-tab">
                  <table class="table mb-0">
                    <tbody>
                    <tr>
                      <th scope="row" style="width: 200px">
                        {{ $t('page.device_name') }}
                      </th>
                      <td>{{ getField('name') }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t('page.device_category') }}</th>
                      <td>{{ getField('product_type_txt') }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t('page.model') }}</th>
                      <td>{{ getField('model') }}</td>
                    </tr>
                    <!-- <tr>
                      <th scope="row">规格</th>
                      <td>-</td>
                    </tr> -->
                    <tr>
                      <th scope="row">{{ $t('page.status') }}</th>
                      <td>{{ user&&user.user_type==='customer'?'在线':getField('status') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div v-show="checkTabVal == '2'" class="tab-content border border-top-0 p-4">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="nav-speci-tab">
                  <table class="table table-responsive align-middle table-nowrap mb-0">
                    <thead class="table-light">
                    <tr class="text-muted">
                      <th>{{ $t('page.work-order.number') }}</th>
                      <th>{{ $t('page.work-order.type.text') }}</th>
                      <th>{{ $t('page.complete-time') }}</th>
                      <th>{{ $t('page.engineer') }}</th>
                      <th>{{ $t('page.service-company') }}</th>
                    </tr>
                    </thead>
                    <tbody class="list form-check-all">
                    <tr v-for="(item, index) in dataList" :key="index">
                      <td>{{ item.number }}</td>
                      <td>{{ WO_TYPE.find(x => x.value == item.type).label || '' }}</td>
                      <td>{{ formatDatetime(item.complete_at) }}</td>
                      <td>{{ item.main_engineer_txt }}</td>
                      <td>{{ item.service_company_txt }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>


              <div v-show="checkTabVal == '3'" class="tab-content border border-top-0 p-4">
                <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="nav-speci-tab">
                  <table class="table table-responsive align-middle table-nowrap mb-0">
                    <thead class="table-light">
                    <tr class="text-muted">
                      <th>{{this.$t('page.work-order.PackageName')}}</th>
                      <th>{{this.$t('page.work-order.PackageContent')}}</th>
                      <th>{{this.$t('page.work-order.ExpirationOfValidity')}}</th>
                      <th>{{this.$t('page.user.status')}}</th>
                    </tr>
                    </thead>
                    <tbody class="list form-check-all">
                    <tr v-for="(item, index) in maintenancePackage" :key="index">
                      <td>{{ item.title }}</td>
                      <td>{{ item.content }}</td>
                      <td>{{ item.expireAt }}</td>
                      <td>
                        <span v-if="item.status == this.$t('page.work-order.Expires')" class="badge badge-soft-dark">{{ item.status }}</span>
                        <span v-if="item.status == this.$t('page.valid')" class="badge badge-soft-success">{{ item.status }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>




            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

</template>
